<template>
  <VWidget
    v-if="selectedZone"
    title="Locations"
    class="mt-5"
  >
    <div slot="widget-header-action" />
    <div
      slot="widget-content"
      class="ma-2"
    >
      <v-flex xs12>
        <h3 class="mb-4">{{ $t('Zone meta info') }}</h3>
        <v-text-field
          v-model="selectedZone.label"
          :error-messages="verrors('label')"
          :label="$t('Zone name')"
          outline
        />
        <v-text-field
          v-model="selectedZone.code"
          :error-messages="verrors('code')"
          :label="$t('Zone code')"
          outline
        />
      </v-flex>
      <v-btn
        v-if="selectedZone.id"
        @click="updateZone()"
      >
        {{ $t('Update meta') }}
      </v-btn>
      <div
        class="mt-4"
      >
        <Territories
          v-if="selectedZone.id"
          :territories="territories"
          :zone="selectedZone"
          class="mb-4"
          @updateZoneTerritories="updateZoneTerritories"
        />
      </div>
      <v-btn
        v-if="!selectedZone.id"
        @click="saveZone()"
      >
        {{ $t('Create zone') }}
      </v-btn>
      <v-btn
        v-if="selectedZone.id"
        @click="deleteZone()"
      >
        {{ $t('Delete Zone') }}
      </v-btn>
    </div>
  </VWidget>
  <LoadingState
    v-else
    :loading="true"
  />
</template>

<script>
import TerritoryForm from '@/modules/Settings/components/Locatisation/TerritoryForm'
import Territories from '@/modules/Settings/components/Locatisation/Territories'
import LoadingState from '@/components/LoadingState'

export default {
  name: 'ZoneForm',

  components: {
    TerritoryForm,
    Territories,
    LoadingState
  },

  props: {
    selectedZoneId: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      selectedZone: null,
      territories: []
    }
  },

  computed: {
    verrors () {
      return field => {
        if (!this.selectedZone.errors) {
          return []
        }
        return this.selectedZone.errors
          .filter(obj => obj.field === field)
          .map(obj => obj.message)
          .flat()
      }
    }
  },

  async created () {
    if (this.selectedZoneId) {
      this.setZone()
      return
    }
    this.selectedZone = await this.$http.make('zones')
  },

  methods: {
    async updateZoneTerritories () {
      this.setZone()
    },

    async setZone () {
      this.selectedZone = await this.$http.make('zones').find(this.selectedZoneId)
      this.territories = this.selectedZone.territories
    },

    async updateZone () {
      await this.selectedZone.validate()
      if (this.selectedZone.errors.length) { return }
      await this.saveZone()
    },

    async deleteZone () {
      const name = this.selectedZone.label
      await this.selectedZone.delete()
      this.$emit('close-drawer')
      this.$radio.$emit('item-saved', { message: `${name} deleted` })
    },

    async saveZone () {
      const name = this.selectedZone.label
      await this.selectedZone
        .save()
        .then(async () => {
          this.$emit('close-drawer')
          this.$radio.$emit('item-saved', { message: `${name} saved` })
        })
        .catch(e => {
          this.$vuetify.goTo(0)
          this.$radio.$emit('api-error', { message: 'Validation failed', errors: this.selectedZone.errors })
        })
    }
  }
}
</script>

<style>

</style>
